import { useLocalStorage } from "@rehooks/local-storage";

export type DoraChartType = "line" | "bar";

const STORAGE_PREFIX = "dora-chart-type-";

const useDoraChartType = (widgetKey: string) => {
  const [chartType, setChartType] = useLocalStorage<DoraChartType>(
    `${STORAGE_PREFIX}${widgetKey}`,
    "line"
  );

  return { chartType, onChange: setChartType };
};

export default useDoraChartType;
